import React, { useState } from 'react';
import LocationTree from '../../LocationTree';
import Modal from '../../Modal';
import LocationTypeModal from '../../LocationTypeModal';
import ParentSelectorTree from '../../components/ParentSelectorTree';

/**
 * 管理 - 設置先階層管理ページ
 */
function Locations({
  selectedCompany,
  locationNodes,
  locationTypes,
  handleAddLocation,
  handleEditLocation,
  handleDeleteLocation,
  handleManageLocationTypes,
  handleAttachWasherToLocation,
  washers,
  showLocationModal,
  setShowLocationModal,
  editingLocation,
  parentLocation,
  setParentLocation,
  locationForm,
  setLocationForm,
  handleSaveLocation,
  showParentSelector,
  setShowParentSelector,
  unassignedRfids,
  theme,
  showLocationTypeModal,
  setShowLocationTypeModal,
  handleAddLocationType,
  handleEditLocationType,
  handleDeleteLocationType,
  showWasherAttachment,
  setShowWasherAttachment,
  attachingLocationNode,
  isAttachingWasher,
  handleDetachWasherFromLocation,
  handleSelectWasherForAttachment
}) {
  const [showConveyorModal, setShowConveyorModal] = useState(false);
  const [selectedConveyor, setSelectedConveyor] = useState(null);

  const handleOpenConveyorDetail = (node) => {
    const detail = {
      locationName: node.location_name || '-',
      locationCode: node.location_code || '-',
      rfidTagId: node.rfid_tag_id || '-',
      conveyorSpec: {
        maker: 'アイウォット機工',
        model: 'IW-CV-300',
        motorModel: 'IM-200V-90W',
        ratedCurrent: '1.8A',
        conveyorType: '平ベルトコンベア',
        totalLength: '2000L',
        effectiveWidth: '300W',
        pulleyDiameter: 'φ80',
        beltSpeed: '15m/min',
        inspectionCycle: '3か月'
      },
      beltSpec: {
        maker: 'アイウォットベルト',
        modelNo: 'NS41UFG0/2Ｗ',
        material: 'ウレタン',
        length: '２０００Ｌ',
        width: '３００ｗ',
        thickness: '1.6mm',
        jointType: 'フィンガーエンドレス',
        antiWanderCleat: 'ＭＳ桟　裏面センター',
        inStock: 'あり'
      },
      history: [
        {
          installedAt: '2026-04-01',
          removedAt: '-',
          damageType: '軽微な摩耗',
          damagePhoto: '未登録',
          estimatedCause: '通常摩耗（定期交換推奨）'
        }
      ]
    };

    setSelectedConveyor(detail);
    setShowConveyorModal(true);
  };

  // 設置先と洗浄機のマッピングを作成
  const washersMap = {};
  washers.forEach((washer) => {
    if (washer.current_location_node_id) {
      if (!washersMap[washer.current_location_node_id]) {
        washersMap[washer.current_location_node_id] = [];
      }
      washersMap[washer.current_location_node_id].push(washer);
    }
  });

  return (
    <div>
      <div style={{ marginBottom: '20px' }}>
        <h2>設置先階層管理</h2>
      </div>

      {selectedCompany ? (
        <div>
          <LocationTree
            company={selectedCompany}
            locationNodes={locationNodes}
            locationTypes={locationTypes}
            onAdd={handleAddLocation}
            onEdit={handleEditLocation}
            onDelete={handleDeleteLocation}
            onManageTypes={handleManageLocationTypes}
            onAttachWasher={handleAttachWasherToLocation}
            washersMap={washersMap}
            onOpenConveyorDetail={handleOpenConveyorDetail}
          />

          {/* コンベア詳細ポップアップ */}
          {showConveyorModal && selectedConveyor && (
            <Modal
              title="コンベア詳細"
              onClose={() => setShowConveyorModal(false)}
              width="860px"
            >
              <div style={{ marginBottom: '14px', padding: '12px', borderRadius: '6px', background: theme === 'dark' ? '#2f3844' : '#f7fafc' }}>
                <strong>{selectedConveyor.locationName}</strong>
                <span style={{ marginLeft: '10px', color: theme === 'dark' ? '#a8b3c2' : '#4a5568' }}>({selectedConveyor.locationCode})</span>
                <div style={{ marginTop: '6px', fontSize: '13px', color: theme === 'dark' ? '#a8b3c2' : '#4a5568' }}>
                  RFIDタグ: {selectedConveyor.rfidTagId}
                </div>
              </div>

              <div style={{ marginBottom: '14px' }}>
                <h4 style={{ marginBottom: '8px' }}>コンベア仕様</h4>
                <table style={{ width: '100%', fontSize: '14px', borderCollapse: 'collapse' }}>
                  <tbody>
                    <tr><th style={{ textAlign: 'left', width: '160px', padding: '6px' }}>メーカー</th><td style={{ padding: '6px' }}>{selectedConveyor.conveyorSpec.maker}</td></tr>
                    <tr><th style={{ textAlign: 'left', padding: '6px' }}>型式</th><td style={{ padding: '6px' }}>{selectedConveyor.conveyorSpec.model}</td></tr>
                    <tr><th style={{ textAlign: 'left', padding: '6px' }}>モーター型式</th><td style={{ padding: '6px' }}>{selectedConveyor.conveyorSpec.motorModel}</td></tr>
                    <tr><th style={{ textAlign: 'left', padding: '6px' }}>定格電流値</th><td style={{ padding: '6px' }}>{selectedConveyor.conveyorSpec.ratedCurrent}</td></tr>
                    <tr><th style={{ textAlign: 'left', padding: '6px' }}>コンベア種別</th><td style={{ padding: '6px' }}>{selectedConveyor.conveyorSpec.conveyorType}</td></tr>
                    <tr><th style={{ textAlign: 'left', padding: '6px' }}>全長</th><td style={{ padding: '6px' }}>{selectedConveyor.conveyorSpec.totalLength}</td></tr>
                    <tr><th style={{ textAlign: 'left', padding: '6px' }}>有効幅</th><td style={{ padding: '6px' }}>{selectedConveyor.conveyorSpec.effectiveWidth}</td></tr>
                    <tr><th style={{ textAlign: 'left', padding: '6px' }}>プーリー径</th><td style={{ padding: '6px' }}>{selectedConveyor.conveyorSpec.pulleyDiameter}</td></tr>
                    <tr><th style={{ textAlign: 'left', padding: '6px' }}>ベルト速度</th><td style={{ padding: '6px' }}>{selectedConveyor.conveyorSpec.beltSpeed}</td></tr>
                    <tr><th style={{ textAlign: 'left', padding: '6px' }}>点検周期</th><td style={{ padding: '6px' }}>{selectedConveyor.conveyorSpec.inspectionCycle}</td></tr>
                  </tbody>
                </table>
              </div>

              <div style={{ marginBottom: '14px' }}>
                <h4 style={{ marginBottom: '8px' }}>コンベアベルト情報</h4>
                <table style={{ width: '100%', fontSize: '14px', borderCollapse: 'collapse' }}>
                  <tbody>
                    <tr><th style={{ textAlign: 'left', width: '160px', padding: '6px' }}>メーカー</th><td style={{ padding: '6px' }}>{selectedConveyor.beltSpec.maker}</td></tr>
                    <tr><th style={{ textAlign: 'left', padding: '6px' }}>型番</th><td style={{ padding: '6px' }}>{selectedConveyor.beltSpec.modelNo}</td></tr>
                    <tr><th style={{ textAlign: 'left', padding: '6px' }}>材質</th><td style={{ padding: '6px' }}>{selectedConveyor.beltSpec.material}</td></tr>
                    <tr><th style={{ textAlign: 'left', padding: '6px' }}>長さ</th><td style={{ padding: '6px' }}>{selectedConveyor.beltSpec.length}</td></tr>
                    <tr><th style={{ textAlign: 'left', padding: '6px' }}>幅</th><td style={{ padding: '6px' }}>{selectedConveyor.beltSpec.width}</td></tr>
                    <tr><th style={{ textAlign: 'left', padding: '6px' }}>厚み</th><td style={{ padding: '6px' }}>{selectedConveyor.beltSpec.thickness}</td></tr>
                    <tr><th style={{ textAlign: 'left', padding: '6px' }}>接合方式</th><td style={{ padding: '6px' }}>{selectedConveyor.beltSpec.jointType}</td></tr>
                    <tr><th style={{ textAlign: 'left', padding: '6px' }}>蛇行防止桟</th><td style={{ padding: '6px' }}>{selectedConveyor.beltSpec.antiWanderCleat}</td></tr>
                    <tr><th style={{ textAlign: 'left', padding: '6px' }}>在庫の有無</th><td style={{ padding: '6px' }}>{selectedConveyor.beltSpec.inStock}</td></tr>
                  </tbody>
                </table>
                <div style={{ marginTop: '10px', display: 'flex', gap: '8px' }}>
                  <button type="button" className="btn btn-secondary">見積依頼</button>
                  <button type="button" className="btn btn-primary">発注</button>
                </div>
              </div>

              <div>
                <h4 style={{ marginBottom: '8px' }}>コンベア履歴</h4>
                <table style={{ width: '100%', fontSize: '13px', borderCollapse: 'collapse' }}>
                  <thead>
                    <tr>
                      <th style={{ textAlign: 'left', padding: '6px' }}>取り付け日</th>
                      <th style={{ textAlign: 'left', padding: '6px' }}>取り外し日</th>
                      <th style={{ textAlign: 'left', padding: '6px' }}>損傷種別</th>
                      <th style={{ textAlign: 'left', padding: '6px' }}>損傷写真</th>
                      <th style={{ textAlign: 'left', padding: '6px' }}>原因推定</th>
                    </tr>
                  </thead>
                  <tbody>
                    {selectedConveyor.history.map((item, idx) => (
                      <tr key={idx}>
                        <td style={{ padding: '6px' }}>{item.installedAt}</td>
                        <td style={{ padding: '6px' }}>{item.removedAt}</td>
                        <td style={{ padding: '6px' }}>{item.damageType}</td>
                        <td style={{ padding: '6px' }}>{item.damagePhoto}</td>
                        <td style={{ padding: '6px' }}>{item.estimatedCause}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </Modal>
          )}

          {/* 設置先登録・編集モーダル */}
          {showLocationModal && (
            <Modal
              title={editingLocation ? '設置先情報編集' : '設置先追加'}
              onClose={() => setShowLocationModal(false)}
              width="550px"
            >
                
                {/* 編集時：親設置先は変更不可で表示のみ */}
                {editingLocation && parentLocation && (
                  <div style={{ marginBottom: '16px', padding: '12px', background: theme === 'dark' ? '#2f3844' : '#f7fafc', borderRadius: '6px', fontSize: '14px' }}>
                    親設置先: <strong>{parentLocation.location_name}</strong>
                    <div style={{ color: '#718096', fontSize: '12px', marginTop: '4px' }}>
                      親設置先を変更する場合は、一度キャンセルして階層から再度追加してください
                    </div>
                  </div>
                )}
                {editingLocation && !parentLocation && (
                  <div style={{ marginBottom: '16px', padding: '12px', background: theme === 'dark' ? '#3a2f1f' : '#fffaf0', borderRadius: '6px', fontSize: '14px', borderLeft: '4px solid #ed8936' }}>
                    ルート設置先として登録されています
                  </div>
                )}
                
                {/* 新規登録時：親設置先を選択可能 */}
                {!editingLocation && (
                  <div className="form-group">
                    <label>親設置先</label>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                      <button
                        type="button"
                        className="btn btn-secondary"
                        onClick={() => setShowParentSelector(true)}
                        style={{ flexShrink: 0 }}
                      >
                        {parentLocation ? '変更' : '選択'}
                      </button>
                      <div style={{ flex: 1, padding: '8px 12px', background: theme === 'dark' ? '#2f3844' : '#f7fafc', borderRadius: '4px', fontSize: '14px' }}>
                        {parentLocation ? (
                          <span>{parentLocation.location_name}</span>
                        ) : (
                          <span style={{ color: '#a0aec0' }}>（ルート直下）</span>
                        )}
                      </div>
                      {parentLocation && (
                        <button
                          type="button"
                          className="btn btn-sm btn-secondary"
                          onClick={() => {
                            setParentLocation(null);
                            // ルートに戻す
                            setLocationForm(prev => ({ ...prev, sort_order: 0 }));
                          }}
                          style={{ flexShrink: 0 }}
                        >
                          クリア
                        </button>
                      )}
                    </div>
                    <small style={{ color: '#718096', display: 'block', marginTop: '4px' }}>
                      ボタンをクリックして階層ツリーから親設置先を選択してください
                    </small>
                  </div>
                )}

                <div className="form-group">
                  <label>設置先種別 *</label>
                  <select
                    value={locationForm.location_node_type_id}
                    onChange={(e) => {
                      const newTypeId = parseInt(e.target.value);
                      const selectedType = locationTypes.find(t => t.location_node_type_id === newTypeId);
                      // has_rfid=falseの種別を選択した場合、RFIDをクリア
                      if (selectedType && !selectedType.has_rfid) {
                        setLocationForm({ ...locationForm, location_node_type_id: newTypeId, rfid_tag_id: '' });
                      } else {
                        setLocationForm({ ...locationForm, location_node_type_id: newTypeId });
                      }
                    }}
                  >
                    <option value="">選択してください</option>
                    {(() => {
                      // 親ノードがある場合は、親のsort_orderより大きい種別のみ表示
                      let availableTypes = locationTypes;
                      if (parentLocation && parentLocation.location_node_type_id) {
                        const parentType = locationTypes.find(t => t.location_node_type_id === parentLocation.location_node_type_id);
                        if (parentType) {
                          availableTypes = locationTypes.filter(t => t.sort_order > parentType.sort_order);
                        }
                      }
                      return availableTypes.map((type) => (
                        <option key={type.location_node_type_id} value={type.location_node_type_id}>
                          {type.type_name_ja} ({type.type_name_en}){type.has_rfid && ' [RFID有]'}
                        </option>
                      ));
                    })()}
                  </select>
                  {locationTypes.length === 0 && (
                    <small style={{ color: '#e53e3e' }}>
                      設置先種別が登録されていません。「設置先種別マスタ管理」から登録してください。
                    </small>
                  )}
                  {parentLocation && parentLocation.location_node_type_id && (() => {
                    const parentType = locationTypes.find(t => t.location_node_type_id === parentLocation.location_node_type_id);
                    const availableTypes = parentType ? locationTypes.filter(t => t.sort_order > parentType.sort_order) : locationTypes;
                    if (availableTypes.length === 0) {
                      return (
                        <small style={{ color: '#e53e3e', display: 'block', marginTop: '4px' }}>
                          選択した親設置先の下に追加できる種別がありません。
                        </small>
                      );
                    }
                  })()}
                </div>

                <div className="form-group">
                  <label>設置先コード</label>
                  <input
                    type="text"
                    value={locationForm.location_code}
                    onChange={(e) => setLocationForm({ ...locationForm, location_code: e.target.value })}
                    placeholder="例: L001"
                  />
                </div>

                <div className="form-group">
                  <label>設置先名 *</label>
                  <input
                    type="text"
                    value={locationForm.location_name}
                    onChange={(e) => setLocationForm({ ...locationForm, location_name: e.target.value })}
                    placeholder="例: A号ライン"
                  />
                </div>

                {/* RFIDタグID：選択された種別がhas_rfid=trueの場合のみ表示 */}
                {(() => {
                  const selectedType = locationTypes.find(t => t.location_node_type_id === locationForm.location_node_type_id);
                  if (!selectedType || !selectedType.has_rfid) {
                    return null; // has_rfid=falseまたは未選択の場合はRFIDフィールドを表示しない
                  }
                  return (
                    <div className="form-group">
                      <label>RFIDタグID</label>
                      <small style={{ display: 'block', color: '#718096', marginBottom: '4px' }}>
                        未割り当てRFIDから選択するか、直接入力してください
                      </small>
                      <select
                        value={locationForm.rfid_tag_id}
                        onChange={(e) => setLocationForm({ ...locationForm, rfid_tag_id: e.target.value })}
                        style={{ marginBottom: '8px' }}
                      >
                        <option value="">-- 選択してください --</option>
                        {unassignedRfids.map((item) => (
                          <option key={item.rfid_tag_id} value={item.rfid_tag_id}>
                            {item.rfid_tag_id} (最終検出: {new Date(item.last_seen).toLocaleString('ja-JP')})
                          </option>
                        ))}
                      </select>
                      <input
                        type="text"
                        value={locationForm.rfid_tag_id}
                        onChange={(e) => setLocationForm({ ...locationForm, rfid_tag_id: e.target.value })}
                        placeholder="または直接入力: 例 RFID-LINE-A001"
                      />
                      {unassignedRfids.length === 0 && (
                        <small style={{ color: '#718096', marginTop: '4px', display: 'block' }}>
                          現在、未割り当てのRFIDはありません
                        </small>
                      )}
                    </div>
                  );
                })()}

                <div className="form-group">
                  <label>並び順</label>
                  <input
                    type="number"
                    value={locationForm.sort_order}
                    onChange={(e) => setLocationForm({ ...locationForm, sort_order: parseInt(e.target.value) || 0 })}
                  />
                </div>

                <div className="form-group">
                  <label style={{ display: 'flex', alignItems: 'center' }}>
                    <input
                      type="checkbox"
                      checked={locationForm.is_active}
                      onChange={(e) => setLocationForm({ ...locationForm, is_active: e.target.checked })}
                      style={{ marginRight: '8px', width: 'auto' }}
                    />
                    有効
                  </label>
                </div>

                <div className="modal-actions">
                  <button className="btn btn-secondary" onClick={() => setShowLocationModal(false)}>
                    キャンセル
                  </button>
                  <button 
                    className="btn btn-primary" 
                    onClick={handleSaveLocation}
                    disabled={!locationForm.location_name || !locationForm.location_node_type_id}
                  >
                    {editingLocation ? '更新' : '追加'}
                  </button>
                </div>
            </Modal>
          )}

          {/* 親設置先選択モーダル（ツリー表示） */}
          {showParentSelector && (
            <Modal
              title="親設置先を選択"
              onClose={() => setShowParentSelector(false)}
              width="600px"
            >
                <p style={{ color: '#718096', fontSize: '14px', marginBottom: '16px' }}>
                  階層ツリーから親設置先を選択するか、「ルート直下」を選択してください。
                </p>
                
                {/* ルート直下オプション */}
                <div
                  style={{
                    padding: '12px',
                    margin: '8px 0',
                    background: parentLocation === null ? (theme === 'dark' ? '#1a3a52' : '#e6f7ff') : (theme === 'dark' ? '#2f3844' : '#f7fafc'),
                    border: parentLocation === null ? '2px solid #1890ff' : (theme === 'dark' ? '1px solid #3d4858' : '1px solid #e2e8f0'),
                    borderRadius: '6px',
                    cursor: 'pointer',
                    fontSize: '14px',
                    fontWeight: parentLocation === null ? 'bold' : 'normal'
                  }}
                  onClick={() => {
                    setParentLocation(null);
                    // ルート直下の場合、最初の階層種別を選択（RFIDがあればhas_rfid=1の中から）
                    if (locationForm.rfid_tag_id) {
                      // RFIDがある場合、has_rfid=1の最初の種別
                      const rfidTypes = locationTypes.filter(t => t.has_rfid === 1);
                      if (rfidTypes.length > 0) {
                        rfidTypes.sort((a, b) => a.sort_order - b.sort_order);
                        setLocationForm(prev => ({ ...prev, location_node_type_id: rfidTypes[0].location_node_type_id, sort_order: 0 }));
                      }
                    } else {
                      // RFIDがない場合、sort_orderが最小の種別
                      const sortedTypes = [...locationTypes].sort((a, b) => a.sort_order - b.sort_order);
                      if (sortedTypes.length > 0) {
                        setLocationForm(prev => ({ ...prev, location_node_type_id: sortedTypes[0].location_node_type_id, sort_order: 0 }));
                      }
                    }
                    setShowParentSelector(false);
                  }}
                >
                  📁 （ルート直下）
                </div>

                {/* 階層ツリー */}
                <div style={{ marginTop: '16px', maxHeight: '400px', overflowY: 'auto', border: theme === 'dark' ? '1px solid #3d4858' : '1px solid #e2e8f0', borderRadius: '4px', padding: '8px' }}>
                  {locationNodes.length === 0 ? (
                    <p style={{ color: '#a0aec0', fontSize: '14px', textAlign: 'center', padding: '24px' }}>
                      設置先階層がまだ登録されていません
                    </p>
                  ) : (
                    <ParentSelectorTree
                      nodes={locationNodes}
                      selectedNode={parentLocation}
                      theme={theme}
                      onSelect={(node) => {
                        setParentLocation(node);
                        // 親の次の階層種別を自動選択
                        const parentType = locationTypes.find(t => t.location_node_type_id === node.location_node_type_id);
                        if (parentType) {
                          const nextTypes = locationTypes.filter(t => t.sort_order > parentType.sort_order);
                          if (nextTypes.length > 0) {
                            nextTypes.sort((a, b) => a.sort_order - b.sort_order);
                            setLocationForm(prev => ({ ...prev, location_node_type_id: nextTypes[0].location_node_type_id }));
                          }
                        }
                        // 兄弟ノードの数から並び順を設定
                        const siblings = node.children || [];
                        setLocationForm(prev => ({ ...prev, sort_order: siblings.length + 1 }));
                        setShowParentSelector(false);
                      }}
                    />
                  )}
                </div>

                <div style={{ marginTop: '24px', display: 'flex', justifyContent: 'flex-end' }}>
                  <button className="btn btn-secondary" onClick={() => setShowParentSelector(false)}>
                    閉じる
                  </button>
                </div>
            </Modal>
          )}

          {/* 設置先種別マスタ管理モーダル */}
          {showLocationTypeModal && (
            <LocationTypeModal
              company={selectedCompany}
              locationTypes={locationTypes}
              onClose={() => setShowLocationTypeModal(false)}
              onAdd={handleAddLocationType}
              onEdit={handleEditLocationType}
              onDelete={handleDeleteLocationType}
            />
          )}
        </div>
      ) : (
        <div style={{ padding: '40px', textAlign: 'center', color: '#718096' }}>
          会社管理画面から「設置先階層」ボタンをクリックして、設置先階層を管理してください。
        </div>
      )}
      
      {/* 設置先から洗浄機を設置するモーダル */}
      {showWasherAttachment && attachingLocationNode && (
        <Modal
          title="洗浄機管理"
          onClose={() => setShowWasherAttachment(false)}
          width="700px"
        >
            <div style={{ marginBottom: '20px', padding: '12px', background: theme === 'dark' ? '#2f3844' : '#f7fafc', borderRadius: '6px' }}>
              <strong>設置先:</strong> {attachingLocationNode.location_name}
            </div>
              
              {/* 設置済の洗浄機セクション */}
              <div style={{ marginBottom: '24px' }}>
                <h4 style={{ marginBottom: '12px', color: theme === 'dark' ? '#dae3ed' : '#2d3748' }}>設置済の洗浄機</h4>
                <div style={{ maxHeight: '250px', overflowY: 'auto', border: theme === 'dark' ? '1px solid #3d4858' : '1px solid #e2e8f0', borderRadius: '6px' }}>
                  {washers.filter(w => w.current_location_node_id === attachingLocationNode.location_node_id).length === 0 ? (
                    <div style={{ padding: '20px', textAlign: 'center', color: '#718096' }}>
                      この設置先に設置されている洗浄機はありません
                    </div>
                  ) : (
                    <table style={{ width: '100%', fontSize: '14px' }}>
                      <thead>
                        <tr style={{ background: theme === 'dark' ? '#2f3844' : '#f7fafc' }}>
                          <th style={{ padding: '8px', textAlign: 'left', borderBottom: theme === 'dark' ? '1px solid #3d4858' : '1px solid #e2e8f0' }}>洗浄機名</th>
                          <th style={{ padding: '8px', textAlign: 'left', borderBottom: theme === 'dark' ? '1px solid #3d4858' : '1px solid #e2e8f0' }}>コード</th>
                          <th style={{ padding: '8px', textAlign: 'center', borderBottom: theme === 'dark' ? '1px solid #3d4858' : '1px solid #e2e8f0' }}>操作</th>
                        </tr>
                      </thead>
                      <tbody>
                        {washers.filter(w => w.current_location_node_id === attachingLocationNode.location_node_id).map((washer) => (
                          <tr key={washer.washer_id}>
                            <td style={{ padding: '8px', borderBottom: theme === 'dark' ? '1px solid #2f3844' : '1px solid #f7fafc' }}>{washer.washer_name}</td>
                            <td style={{ padding: '8px', borderBottom: theme === 'dark' ? '1px solid #2f3844' : '1px solid #f7fafc' }}>
                              <code style={{ background: theme === 'dark' ? '#3d4858' : '#edf2f7', padding: '2px 6px', borderRadius: '3px', fontSize: '12px' }}>
                                {washer.washer_code}
                              </code>
                            </td>
                            <td style={{ padding: '8px', textAlign: 'center', borderBottom: theme === 'dark' ? '1px solid #2f3844' : '1px solid #f7fafc' }}>
                              <button 
                                className="btn-small btn-danger"
                                onClick={() => handleDetachWasherFromLocation(washer)}
                                disabled={isAttachingWasher}
                              >
                                {isAttachingWasher ? '処理中...' : '解除'}
                              </button>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  )}
                </div>
              </div>

              {/* 未設置の洗浄機セクション */}
              <div>
                <h4 style={{ marginBottom: '12px', color: theme === 'dark' ? '#dae3ed' : '#2d3748' }}>設置可能な洗浄機</h4>
                <div style={{ maxHeight: '250px', overflowY: 'auto', border: theme === 'dark' ? '1px solid #3d4858' : '1px solid #e2e8f0', borderRadius: '6px' }}>
                  {washers.filter(w => !w.current_location_node_id).length === 0 ? (
                    <div style={{ padding: '20px', textAlign: 'center', color: '#718096' }}>
                      設置可能な洗浄機がありません
                    </div>
                  ) : (
                    <table style={{ width: '100%', fontSize: '14px' }}>
                      <thead>
                        <tr style={{ background: theme === 'dark' ? '#2f3844' : '#f7fafc' }}>
                          <th style={{ padding: '8px', textAlign: 'left', borderBottom: theme === 'dark' ? '1px solid #3d4858' : '1px solid #e2e8f0' }}>洗浄機名</th>
                          <th style={{ padding: '8px', textAlign: 'left', borderBottom: theme === 'dark' ? '1px solid #3d4858' : '1px solid #e2e8f0' }}>コード</th>
                          <th style={{ padding: '8px', textAlign: 'center', borderBottom: theme === 'dark' ? '1px solid #3d4858' : '1px solid #e2e8f0' }}>操作</th>
                        </tr>
                      </thead>
                      <tbody>
                        {washers.filter(w => !w.current_location_node_id).map((washer) => (
                          <tr key={washer.washer_id}>
                            <td style={{ padding: '8px', borderBottom: theme === 'dark' ? '1px solid #2f3844' : '1px solid #f7fafc' }}>{washer.washer_name}</td>
                            <td style={{ padding: '8px', borderBottom: theme === 'dark' ? '1px solid #2f3844' : '1px solid #f7fafc' }}>
                              <code style={{ background: theme === 'dark' ? '#3d4858' : '#edf2f7', padding: '2px 6px', borderRadius: '3px', fontSize: '12px' }}>
                                {washer.washer_code}
                              </code>
                            </td>
                            <td style={{ padding: '8px', textAlign: 'center', borderBottom: theme === 'dark' ? '1px solid #2f3844' : '1px solid #f7fafc' }}>
                              <button 
                                className="btn-small btn-primary"
                                onClick={() => handleSelectWasherForAttachment(washer)}
                                disabled={isAttachingWasher}
                              >
                                {isAttachingWasher ? '処理中...' : '設置'}
                              </button>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  )}
                </div>
              </div>
        </Modal>
      )}
    </div>
  );
}

export default Locations;
